<template>
  <div class="resultsV2-badge-item" v-if="badgeObject">
    <div class="resultsV2-badge-logo-zone">
      <img class="resultsV2-badge-logo-logo " alt="" :src="badgeObject.img" />
    </div>
    <div class="resultsV2-badge-text-zone">
      <span class="resultsV2-badge-text-title">{{ badgeObject.title }}</span>
      <span class="resultsV2-badge-text-text">{{ badgeObject.description.candidate }}</span>
    </div>
  </div>
</template>

<script setup>
import badges from "@/assets/badges.json";
import { computed } from "vue";

const props = defineProps({
  badge: {
    type: String,
    required: true,
  },
});

const badgeObject = computed(() => badges[props.badge] || undefined);
</script>

<style>
.resultsV2-badge-item {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  flex-wrap: nowrap;
  flex-shrink: 0;
  gap: 40px;
  position: relative;
  padding-bottom: 24px;
}

.resultsV2-badge-logo-zone {
  flex-shrink: 0;
  position: relative;
  width: 108px;
  height: 100px;
}

.resultsV2-badge-logo-logo {
  position: absolute;
  top: 0%;
  left: 8%;
}

.resultsV2-badge-logo-text-area {
  position: absolute;
  width: 108px;
  height: 28.001px;
  top: 63px;
  left: 0;
}

.resultsV2-badge-logo-text-bg {
  position: absolute;
  width: 92px;
  height: 23px;
  top: 0;
  left: 8px;
  background: #f2cb36;
  border-radius: 4px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.16);
}

.resultsV2-badge-logo-text {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 53.7%;
  height: 42.86%;
  top: 21.43%;
  left: 23.15%;
  color: rgba(0, 0, 0, 0.32);
  font-family: "Bio Sans-Regular", Helvetica;
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.24);
}

.resultsV2-badge-text-zone {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 0;
  gap: 8px;
  position: relative;
}

.resultsV2-badge-text-title {
  align-self: stretch;
  flex-shrink: 0;
  flex-basis: auto;
  position: relative;
  color: #ffffff;
  font-family: "Bio Sans-Regular", Helvetica;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
}

.resultsV2-badge-text-text {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  color: rgba(255, 255, 255, 0.75);
  font-family: "Bio Sans-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
}
</style>